<template>
  <div>
    <div class="message__try animate__animated animate__fadeInUp animate__faster">
      {{ $i18nPresenter.t('Try') }}:
    </div>
    <div v-for="(suggestion, suggestionIndex) in promptSuggestions" :key="suggestionIndex">
      <div
        @click="onClickSuggestion(suggestion)"
        v-aha-emit-action
        name="ai_prompt_suggestion"
        class="message__suggestion animate__animated animate__fadeInUp animate__faster"
      >
        ✨ {{ suggestion }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    promptSuggestions: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onClickSuggestion(suggestion) {
      this.$emit('clickOnSuggestion', suggestion)
    },
  },
}

</script>

<style lang="scss" scoped>
.message__try {
  @apply text-sm mb-2 break-words;
  color: #545454;
  animation-delay: 0.3s;
}
.message__suggestion {
  @apply bg-base-0 px-3 rounded-lg border border-purple-50 hover:border-purple-100;
  @apply w-max mb-2 text-sm cursor-pointer break-words;
  padding-top: 6px;
  padding-bottom: 6px;
  animation-delay: 0.6s;
}
</style>
